import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';
import { useEndConversation } from '@vs-online-only-app/state';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';
import { Close } from '@mui/icons-material';

const CloseButton = styled(IconButton)`
  position: absolute;
  top: ${({ theme }) => theme.spacing(1)};
  right: ${({ theme }) => theme.spacing(1.5)};
`;

type Props = {
  onClose: () => void;
  isOpen: boolean;
};

export const SelectedConversationEndConfirmationModal: FC<Props> = ({
  onClose,
  isOpen,
}) => {
  const conversation = useSelectedHeroConversation();
  const useEndConversationMutation = useEndConversation();
  if (!conversation) {
    return null;
  }

  const endConversation = () => {
    onClose();
    useEndConversationMutation.mutateAsync(conversation.id);
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <CloseButton onClick={onClose}>
        <Close />
      </CloseButton>
      <DialogTitle>
        End the chat with {conversation.conversationStarter.firstName}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Once a chat is ended, it&apos;ll be moved to{' '}
          <strong>Archived chats</strong> and can only be restarted by the
          customer.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button fullWidth onClick={onClose} variant="outlined">
          Continue to chat
        </Button>
        <Button fullWidth onClick={endConversation} variant="contained">
          Yes, end chat
        </Button>
      </DialogActions>
    </Dialog>
  );
};
